export const CONF_ENVIRONMENT = process.env.REACT_APP_NODE;
export const CONF_API_URL = process.env.REACT_APP_API_URL;
export const CONF_URL_PATIENT = process.env.REACT_APP_URL_PATIENT;
export const CONF_URL_DOCTOR = process.env.REACT_APP_URL_DOCTOR;
export const CONF_SEO_URL = process.env.REACT_APP_SEO_URL;
export const CONF_STRIPE_ID = process.env.REACT_APP_STRIPE_ID;
